import { useHttpClient } from '@/libs/http'

import IStaffService from './staff.interface'
import StaffService from './staff.service'

const useStaffService = (): IStaffService => {
  const { getChannelsInstance } = useHttpClient()
  return new StaffService(getChannelsInstance())
}

export default useStaffService
